export default __webpack_public_path__ + "static/media/Q6-5.473bf1c9.jpg";